import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Backdrop from '@mui/material/Backdrop'
import { COLORS } from '../../utils/colors'

const Spinner = ({ open }: { open: boolean }) => {
  return (
    <Backdrop 
      sx={{ backgroundColor: 'rgba(0, 0, 0, 0)'}}
      open={open}
      >
      <CircularProgress sx={{ color: COLORS.PRIMARY }} />
    </Backdrop>
  );
};

export default Spinner;
